import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import clsx from 'clsx';
import Button from 'carbon-react/lib/components/button';

import { TitleDesc } from './title-desc/title-desc';
import { UIWizardFlowSaving } from '../ui-wizard-flow-saving/ui-wizard-flow-saving';
import styles from './ui-wizard-flow-header.scss';

export interface UIWizardFlowHeaderProps {
  description?: string;
  disableBack?: boolean;
  disableNext?: boolean;
  extraContent?: ReactNode;
  innerContainerClassname?: string;
  onBack?: () => void;
  onNext?: () => void;
  outerContainerClassname?: string;
  saving?: boolean;
  shadow?: boolean;
  title: string;
}

export const UIWizardFlowHeader = ({
  description,
  disableBack,
  disableNext,
  extraContent,
  innerContainerClassname,
  onBack,
  onNext,
  outerContainerClassname,
  saving,
  shadow,
  title
}: UIWizardFlowHeaderProps) => (
  <>
    <div className={clsx(styles.outerContainer, outerContainerClassname, { [styles.shadow]: shadow })}>
      <div className={clsx(styles.container, innerContainerClassname)}>
        <TitleDesc title={title} desc={description} />
        {extraContent}
        <div className={styles.buttonContainer}>
          {onBack && (
            <Button disabled={disableBack} buttonType="secondary" onClick={onBack} size="large" mr="20px">
              <FormattedMessage id="common.back" defaultMessage="Back" />
            </Button>
          )}
          {onNext && (
            <Button disabled={disableNext} onClick={onNext} buttonType="primary" size="large">
              <FormattedMessage id="common.next" defaultMessage="Next" />
            </Button>
          )}
          {saving && <UIWizardFlowSaving />}
        </div>
      </div>
    </div>
  </>
);
